$(document).ready(function () {
var areaHeight = $( window ).height();

$('.tec-chevron').on('click',function(){
    $('html').animate({
        scrollTop : areaHeight
    },1000);
}
);
});